import { DomService } from '../dom';

const RCM_USER_TYPE_KEY = 'RcmUserType';
export const RCM_USER_TYPE_RETAIL = 'retail';
export const RCM_USER_TYPE_INSTI = 'institutional';
export const RCM_USER_TYPE_CEE = 'cee';
export const RCM_CHANNEL_RETAIL = 'Internet-KAG';
export const RCM_CHANNEL_INSTI = 'Internet-KAG%20Institutionell';
export const RCM_NO_USER_TYPE_COUNTRIES = ['li', 'bg', 'pl', 'ro'];

export const AppService = {
  getUrlSearchParams(): URLSearchParams {
    return new URL(window.location.href).searchParams;
  },

  getUserType(): string {
    const { slug } = DomService.getGlobalContent();

    const typeFromSlug = document.location.pathname.includes(slug.retail) ? RCM_USER_TYPE_RETAIL : RCM_USER_TYPE_INSTI;

    return window.localStorage.getItem(RCM_USER_TYPE_KEY) || window.sessionStorage.getItem(RCM_USER_TYPE_KEY) || typeFromSlug || RCM_USER_TYPE_RETAIL;
  },

  userTypeIsStored(): boolean {
    return !!window.localStorage.getItem(RCM_USER_TYPE_KEY) || !!window.sessionStorage.getItem(RCM_USER_TYPE_KEY);
  },

  setUserType(userType: string, persist: boolean = false): void {
    if (persist) {
      window.localStorage.setItem(RCM_USER_TYPE_KEY, userType);
    } else {
      window.sessionStorage.setItem(RCM_USER_TYPE_KEY, userType);
    }
  },

  getChannelByCurrentUserType(): string {
    return this.getUserType() === RCM_USER_TYPE_RETAIL ? RCM_CHANNEL_RETAIL : RCM_CHANNEL_INSTI;
  },
};
